import React from 'react'
import { Text, Label } from '../../generic'
import { Row, Col } from '../../generic/grid'
import { useQuery } from 'react-apollo'
import gql from 'graphql-tag'
import { BankingDetailsContainer, BankingDetailsRow, ReferenceLabel } from './BankDetails.style'
import { RowSpacer } from '../../generic/Layouts'
import { InformationRow } from '../../shared'

const GET_ID_NUMBER = gql`
{
  myClient {
    idNumber
  }
}
`

const getProductBankDetails = (product) => {
  switch (product) {
    case 'CLEARANCE_CERTIFICATE':
      return {
        bankName: 'Nedbank',
        accountHolder: 'Meerkat',
        accountNumber: '1330433947',
        branchCode: '198765',
      }
    default:
      return {
        bankName: 'Nedbank',
        accountHolder: 'Meerkat',
        accountNumber: '1186772700',
        branchCode: '198765',
      }
  }
}

function BankDetails({ reference, product }) {
  const { data } = useQuery(GET_ID_NUMBER)
  const useReference = reference || (data && data.myClient && data.myClient.idNumber) || ""
  const bankDetails = getProductBankDetails(product)
  return (
    <BankingDetailsContainer>
      <BankingDetailsRow>
      <RowSpacer height={12}/>
        <Text size={16} bold>{bankDetails.bankName}</Text>
        <RowSpacer height={6}/>
        <InformationRow title={'Account holder'} value={bankDetails.accountHolder}/>
        <InformationRow title={'Account no.'} value={bankDetails.accountNumber}/>
        {/* <InformationRow title={'Account type'} value={'TODO: add value'}/> */}
        {/* <InformationRow title={'Branch'} value={'TODO: add value'}/> */}
        <InformationRow title={'Branch code'} value={bankDetails.branchCode}/>
      </BankingDetailsRow>
      <BankingDetailsRow>
        <InformationRow title={'Reference'} value={<ReferenceLabel title={useReference} color="primary" textColor="primary"/>}/>
      </BankingDetailsRow>
    </BankingDetailsContainer>
  );
}

export default BankDetails
